<div class="h-[45px] relative select-none">
  <!-- Input Field - NO internal NgModel, just ControlValueAccessor -->
  <input
    [type]="config.type || 'text'"
    pInputText
    [id]="id"
    [name]="name()"
    class="h-[45px] w-full peer"
    [ngClass]="{
      '!bg-gray-50': config.disabled || isDisabled,
      '!text-grey-500': config.disabled || isDisabled,
      '!cursor-not-allowed': config.disabled || isDisabled,
      'select-none': config.disabled || isDisabled,
      'ng-invalid': hasError(),
      'ng-dirty': ngControl?.control?.dirty || formSubmitted()
    }"
    [placeholder]="config.placeholder"
    [value]="value"
    (input)="onInput($event)"
    (blur)="onBlur()"
    [disabled]="config.disabled || isDisabled"
    [autocomplete]="config.autocomplete || 'off'"
    pSize="small" />

  <!-- Floating Label -->
  <label
    [for]="id"
    class="absolute -top-2.5 left-3 bg-white px-1 text-caption transition-colors peer-focus:text-primary-500 text-grey-950"
    [ngClass]="{
      'text-red-500': hasError(),
      'email-disabled-split-bg': config.disabled || isDisabled
    }">
    {{ config.label }}
    @if (config.required) {
      <span class="text-grey-400 ml-1">*</span>
    }
  </label>

  <!-- Loading Indicator (for custom validation like email checking or unique checking) -->
  @if (config.showLoadingIndicator && (customValidationState?.isChecking || (config.isUnique && uniqueValidationState.isChecking))) {
  <div
    class="absolute right-3 top-1/2 transform -translate-y-1/2 select-none">
    <div class="w-4 h-4 border-2 border-primary-200 rounded-full animate-spin border-t-primary-600 select-none"></div>
  </div>
  }

  <!-- Error Messages -->
  <!-- Required Error -->
   @if (shouldShowRequiredError()) {
  <p-message
    severity="error"
    size="small"
    variant="simple">
    {{ requiredErrorMessage() }}
  </p-message>
  }

  <!-- Pattern Error -->
  @if (shouldShowPatternError()) {
  <p-message
    severity="error"
    size="small"
    variant="simple">
    {{ patternErrorMessage() }}
  </p-message>
  }
  <!-- Email Validation Error -->
  @if (shouldShowEmailError()) {
  <p-message
    severity="error"
    size="small"
    variant="simple">
    {{ emailErrorMessage() }}
  </p-message>
  }
  <!-- Custom Validation Error -->
  @if (shouldShowCustomError()) {
  <p-message
    severity="error"
    size="small"
    variant="simple">
    {{ customErrorMessage() }}
  </p-message>
  }
  <!-- Unique Validation Error -->
  @if (shouldShowUniqueError()) {
  <p-message
    severity="error"
    size="small"
    variant="simple">
    {{ uniqueErrorMessage() }}
  </p-message>
  }
</div>
